import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
    UserRegistrationPageComponent
} from './registration/pages/user-registration-landing-page/user-registration-page.component';
import { formNavigationGuard } from './shared/guards/registration-navigation.guard';
import { ErrorComponent } from './error/error.component';
import { UserRegistrationConfirmationPageComponent } from './registration/pages/user-registration-confirmation-page/user-registration-confirmation-page.component';


const routes: Routes = [
    {
        path: '',
        redirectTo: 'registration',
        pathMatch: 'full',
    },
    {
        path: 'registration',
        pathMatch: 'full',
        component: UserRegistrationPageComponent,
        canDeactivate: [formNavigationGuard],
    },
    {
        path: 'registration-confirmation',
        pathMatch: 'full',
        component: UserRegistrationConfirmationPageComponent,
    },
    {
        path: 'error/:errorNumber',
        component: ErrorComponent,
    },
    {
        path: '**',
        redirectTo: 'error/404',
    }
];

export const allRoutes: Routes = [ ...routes];

@NgModule({
    imports: [
      RouterModule.forRoot(allRoutes, {
        scrollPositionRestoration: 'top'
    })],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
